import { TIME_FORMATS_SHORT } from '../constants/date-time-formats';
import moment from 'moment';

export const url = '/myb';

export const getParameterByName = (name) => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' ').toUpperCase());
};

export const getFormatDate = (dato, formato) => {
  return moment( dato ).format( formato );
};

export const getDuration = (dato, formato) => {
  return moment.duration(dato, formato);
};

export const getIsSame = (dato1, dato2, formato) => {
  return moment(dato1).isSame(dato2, formato);
};

export const getTimeFormat = (date, storefront, formatMessage) => {
  if (storefront !== 'us') {
    return getFormatDate(date, TIME_FORMATS_SHORT[storefront]);
  } else {
    const isMorning = date.hour() < 12;
    const dateSuffixCopyID = isMorning ? 'APP_AM_SHORTHAND' : 'APP_PM_SHORTHAND';
    const dateSuffix = formatMessage({ id: dateSuffixCopyID });

    return `${date.format(TIME_FORMATS_SHORT[storefront])}${dateSuffix}`;
  }
};

export const parseCityPairDateCode = (cityPairDateCode) => {
  let itinerary = null;

  if (!cityPairDateCode) {
    return null;
  }

  if (typeof(cityPairDateCode) !== 'string') {
    return null;
  }

  const legCodeArray = cityPairDateCode.split('.');

  const cityPairDateRegex = /^([A-Z]{3})_([A-Z]{3})_([0-9]{4})-([0-9]{2})-([0-9]{2})*$/;
  const cityPairRegex = /^([A-Z]{3})_([A-Z]{3})*$/;

  const isValidWithDates = legCodeArray.every((code) => {
    return cityPairDateRegex.test(code);
  });

  const isValidNoDate = legCodeArray.every((code) => {
    return cityPairRegex.test(code);
  });

  if (isValidWithDates || isValidNoDate) {
    const legRegex = isValidWithDates ? cityPairDateRegex : cityPairRegex;

    itinerary = legCodeArray.map(legCode => {
      const match = legCode.match(legRegex);

      const [
        depYear,
        depMonth,
        depDay,
      ] = match;

      return isValidWithDates ? new Date(depYear, (depMonth - 1), depDay) : null;
    });
  }

  return itinerary;
};

export const getUtc = ( date ) => {
  return moment.utc(parseCityPairDateCode(date));
};

export const getFormatDateTime = (obj, format) => {
  let strReplace = '';
  let response = format;
  if (format !== undefined) {
    Object.keys(obj).forEach( key => {
      if (format.indexOf(key) !== -1) {
        strReplace = `${key}`;

        if (response === 'Dec D') {
          response = 'dec D';
          response = response.replace(strReplace, obj[key]);
          response = response.charAt(0).toUpperCase() + response.slice(1);
        } else {
          response = response.replace(strReplace, obj[key]);
        }

        format = format.replace(strReplace, '');
      }
    });
  }
  return response;
};
